'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.getCookie = undefined;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataOrDefault = function dataOrDefault(data, defaultValue) {
  return (data === null || typeof data === 'undefined') && typeof defaultValue !== 'undefined' ? defaultValue : data;
};

var getCookie = exports.getCookie = function getCookie(cookieName, defaultValue) {
  if (__CLIENT__ || __TEST__) {
    return dataOrDefault(_cookie2.default.parse(document.cookie)[cookieName], defaultValue);
  }
};

// `options` are here: https://www.npmjs.com/package/cookie#options-1
var setCookie = exports.setCookie = function setCookie(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (__CLIENT__ || __TEST__) {
    document.cookie = _cookie2.default.serialize(name, value, options);
  }
};